export function normalizeRut(value) {
  const characters = String(value || "").toUpperCase().replace(/[^0-9K]/g, "");
  return characters.replace(/K(?!$)/g, "").replace(/^K$/, "").slice(0, 9);
}

export function formatRut(value) {
  const rut = normalizeRut(value);
  if (rut.length < 2) return rut;

  const body = rut.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${body}-${rut.slice(-1)}`;
}
